<template>
  <button class="theme-switcher" @click="handleClick">
    <span
      v-for="(theme, i) in themes"
      :key="i"
      :style="{
        borderColor: `var(--${ theme }`,
        backgroundColor: `var(--${ theme })`
      }"
      :class="{
        'theme-switcher__dot--is-active': isActive(theme),
        'theme-switcher__dot--is-animating': isAnimating
      }"
      class="theme-switcher__dot"
      tabindex="-1"
      @transitionend="handleTransitionEnd"
    />
  </button>
</template>

<script>
export default {
  props: {
    themes: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isAnimating: false
    }
  },
  computed: {
    isActive () {
      return theme => theme === this.active
    }
  },
  methods: {
    handleClick (evt) {
      evt.target.blur()
      if (this.isAnimating) return
      this.isAnimating = true
    },
    handleTransitionEnd () {
      if (!this.isAnimating) return
      this.isAnimating = false
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
  $dot-size: 36px;

  .theme-switcher {
    @include reset-button;
    @include vertical-space((top: 1));
    position: relative;

    height: $dot-size;
    width: 1.45 * $dot-size + $accent-border-width;

    cursor: pointer;

    @include media-up(md) {
      @include vertical-space((top: 0));
    }

    &:hover &__dot,
    &:focus &__dot {
      @include media-up(md) {
        &:first-child {
          transform: translate3d(-15%, 0, 0);
        }

        &:last-child {
          transform: translate3d(15%, 0, 0);
        }
      }
    }

    &__dot {
      display: block;
      outline: none;

      border: $accent-border-width solid;
      border-radius: 50%;
      width: $dot-size;
      height: $dot-size;

      position: absolute;
      top: 0;

      transition: transform .3s ease .2s;

      @include media-down(md) {
        border-color: $main-opposite-color !important;
      }

      @include media-up(md) {
        background-color: $bg-color !important;
      }

      &--is-active {
        z-index: 2;
      }

      &:first-child {
        left: 0;
      }

      &:last-child {
        left: $dot-size * 0.55;
      }

      &--is-animating {
        transition: transform $base-transition;
      }

      &--is-animating:first-child {
        transform: translate3d(-27%, 0, 0) !important;

        @include media-up(md) {
          transform: translate3d(-50%, 0, 0) !important;
        }
      }

      &--is-animating:last-child {
        transform: translate3d(27%, 0, 0) !important;

        @include media-up(md) {
          transform: translate3d(50%, 0, 0) !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Navigation/ThemeSwitcher.vue